const decimalToHex = (decimal: number) => {
  return "0x" + decimal.toString(16)
}

export default decimalToHex
